import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import DropDownList from '../dropdown-list/index';
import SearchBox from '../search-box/index';
import '../../styles/core.scss';
import css from './index.scss';
import Button from '../button/index';
import { LIGHT } from '../button/variants';
import messages from './messages';

const findSelected = item => item.selected;

const TeacherFilter = ({ lastNames, classrooms, searchTerm = '', handleFilterOnChange, handleFilterOnClear, handleOnSearch, intl }) => {
    const selectedClassroom = classrooms.find(findSelected);

    lastNames[0].value = intl.formatMessage(messages.allSurnames);
    classrooms[0].value = intl.formatMessage(messages.allClasses);
    classrooms[1].value = intl.formatMessage(messages.UnassignedTeacher);

    return (
        <div className={css.filterContainer}>
            <div className={css.filterContainer}>
                <div className={css.filters}>
                    <div className={css.class}>
                        <DropDownList
                            name="classrooms"
                            onChange={handleFilterOnChange}
                            options={classrooms}
                            value={selectedClassroom.key} /></div>
                    <Button
                        containerClassName={css.clear}
                        disabled={false}
                        handleOnClick={handleFilterOnClear}
                        label={intl.formatMessage(messages.clear)}
                        variant={LIGHT} />
                    <div className={css.teacherSearchContainer}>
                        <SearchBox handleOnSearchClick={handleOnSearch} searchTerm={searchTerm} /></div>
                </div>
            </div>
        </div>
    );
};

TeacherFilter.propTypes = {
    lastNames: PropTypes.array,
    classrooms: PropTypes.array,
    searchTerm: PropTypes.string,
    handleFilterOnChange: PropTypes.func,
    handleFilterOnClear: PropTypes.func,
    handleOnSearch: PropTypes.func,
    intl: intlShape.isRequired
};

export default injectIntl(styleable(css)(TeacherFilter));



// WEBPACK FOOTER //
// ./app/components/teacher-filter/index.js